import { render, staticRenderFns } from "./storeRightList.vue?vue&type=template&id=34ba949a&scoped=true&"
import script from "./storeRightList.vue?vue&type=script&lang=js&"
export * from "./storeRightList.vue?vue&type=script&lang=js&"
import style0 from "./storeRightList.vue?vue&type=style&index=0&id=34ba949a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ba949a",
  null
  
)

export default component.exports